import { all, call, SagaReturnType, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  createAdminAction,
  editAdminAction,
  deleteAdminAction,
  loadAdminsAction
} from 'store/administration/administration.actions';
import { createAdmin, deleteAdmin, editAdmin, loadAdmins } from 'api/administration';

function* createAdminFlow(action: typeof createAdminAction.types.triggerAction) {
  try {
    const data: SagaReturnType<typeof createAdmin> = yield call(createAdmin, action.payload);
    yield call(createAdminAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(createAdminAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* loadAdminsFlow(action: typeof loadAdminsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadAdmins> = yield call(loadAdmins, action.payload);
    yield call(loadAdminsAction.sagas.resolve, action, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e: any) {
    yield call(loadAdminsAction.sagas.reject, action, e?.message);
  }
}

function* editAdminFlow(action: typeof editAdminAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof editAdmin> = yield call(editAdmin, action.payload);
    yield call(editAdminAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(editAdminAction.sagas.reject, action, e?.response?.data || e?.message || e);
  }
}

function* deleteAdminFlow(action: typeof deleteAdminAction.types.triggerAction) {
  try {
    yield call(deleteAdmin, action.payload);
    yield call(deleteAdminAction.sagas.resolve, action, '');
  } catch (e: any) {
    yield call(deleteAdminAction.sagas.reject, action, e?.message);
  }
}

export default function* administrationSaga() {
  yield all([
    takeEvery(createAdminAction.trigger, createAdminFlow),
    takeLatest(loadAdminsAction.trigger, loadAdminsFlow),
    takeEvery(editAdminAction.trigger, editAdminFlow),
    takeEvery(deleteAdminAction.trigger, deleteAdminFlow),
  ]);
}